var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"minisite-cube-nav"},[_c(_vm.currentComponent,{key:_vm.data.style.templateId,tag:"component",attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }